import { yupResolver } from "@hookform/resolvers/yup";
import { Box } from "@mui/material"
import { useContext, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { MoonLoader } from "react-spinners"
import * as Yup from 'yup';
import { Input, PromiseLoader } from "react-builder";
import { ProductServerAuthContext } from "../providers/ProductServerAuth";

export interface ILoginFormData {
    email: string;
    password: string;
}

const LoginFormV2 = (props: { style?: React.CSSProperties }) => {

    const { isLoggedIn, isLoginDialogOpen, setLoginDialogOpen, login, logout, loginError } = useContext(ProductServerAuthContext);

    const formSchema = Yup.object().shape({
        email: Yup.string()
            .required('Email is required')
            .matches(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, "Valid email address required"),
        password: Yup.string()
            .required('Password is mendatory')
            .min(3, 'Password must be at 3 char long'),

    })
    const formOptions = { resolver: yupResolver(formSchema) }
    const { register, watch, formState, handleSubmit } = useForm<ILoginFormData>(formOptions);


    const [loginPromise, setLoginPromise] = useState<Promise<any> | undefined>(undefined);

    const onSubmit: SubmitHandler<ILoginFormData> = (data: ILoginFormData) => {
        console.log(data, formState.errors.email);
        setLoginPromise(login(data.email, data.password).then((success) => {
            handleClose();
            return success;
        }))
    }

    const handleClose = () => {
        setLoginDialogOpen(false);
    }

    return <form style={props.style} onSubmit={handleSubmit(onSubmit)} className='login-form' noValidate >
        <Box
            component="div"
            sx={{
                '& .MuiTextField-root': { mx: 1, width: '25ch' },
            }}

        >
            <Input register={register} label="Email" name="email" type="email" error={formState.errors.email}></Input>
            <Input register={register} label="Password" name="password" type="password" error={formState.errors.password}></Input>

        </Box>
        <PromiseLoader<any> promise={loginPromise} loader={<MoonLoader loading={true} size={20} />} overlayColor="rgba(255,255,255,.4)">
            {res => <button type="submit" autoFocus>
                Login
            </button>}
        </PromiseLoader>
        <p className="input-error" >
            {loginError}
        </p>
        <div style={{ marginTop: '18px' }}><a href="#signup" >Create an account</a></div>
        <div><a href="#support/4" >Forgot your password</a></div>
    </form>
}

export default LoginFormV2;